
import { mapState, mapActions } from "vuex";
export default {
  components: {
    MenuDetailHeaderRow: () =>
      import("@/components/menu/menu-detail-header-row.vue"),
    menuItemForm: () => import("@/components/menu/menu-item-form.vue"),
    MenuPendingCatalogueSyncList: () =>
      import("@/components/menu/menu-pending-catalogue-sync-list.vue")
  },
  data() {
    return {
      activeTab: 1,
      loading: false,
      tabs: [
        { id: 1, name: "Item", route: `/menu/${this.$route.params.id}/item` }
        // {
        //   id: 2,
        //   name: "Combo",
        //   route: `/menu/${this.$route.params.id}/combo`
        // },
        // {
        //   id: 3,
        //   name: "Addons",
        //   route: `/menu/${this.$route.params.id}/addons`
        // }
      ]
    };
  },
  async fetch() {
    this.loading = true;
    await Promise.all([
      this.getMenuList(false),
      this.getAddons(),
      this.getCombosList()
    ]);
    this.getSyncStatus();
    this.loading = false;
  },
  beforeMount() {
    window.scrollTo(0, 0);
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    isNew() {
      return this.$route.params.id == "new";
    }
  },
  methods: {
    ...mapActions("menu", [
      "getMenuList",
      "getAddons",
      "getSyncStatus",
      "getCombosList"
    ])
  }
};
